import { ReactNode } from "react";
import { Link } from "react-router-dom";

import { useRoutes } from "web/lib/i18n";
import { IconType } from "web/ui/icons/IconType";

export function ManualSectionLink({
  carId,
  sectionId,
  Icon,
  search,
  children,
}: {
  carId: string;
  sectionId: string;
  Icon?: IconType;
  search: string;
  children: ReactNode;
}) {
  const routes = useRoutes();

  return (
    <Link
      className="block px-2 py-1 md:px-4 md:py-3 mb-3 hover:bg-gray50 hover:text-blue rounded-lg focus:ring-2 focus:ring-blue focus:outline-none"
      to={
        routes.CarManualSection.url({
          carId,
          sectionId,
        }) + search
      }
    >
      <div className="font-display text-lg lg:text-2xl">
        {Icon && <Icon className="nudge-up mr-2" />} {children}
      </div>
    </Link>
  );
}
